import React from 'react';
import { StoryCard } from '../StoryCard';

class PollCard extends StoryCard {
	render() {
		return <div className="poll-card">{super.renderCard()}</div>;
	}
}

export default PollCard;
